import axios from 'axios';

import WP from 'WP';

class Middleware {
    
    constructor({ debug, revisionsFrom }) {
        this.debug = debug;
        this.revisionsFrom = revisionsFrom;
    }

    /**
     * Helper: Logs messages to console if debug is enabled
     * 
     * @param {String} message 
     * @param {String} message2 
     * @param {String} message3 
     */
    log(message, message2='', message3='') {
        if(this.debug) console.log(message, message2, message3);
    }

    /**
     * Returns URL query variables as object
     * 
     * @param {Array} posts 
     */
    parseQueryString = queryString => {
        let params = {}, queries, temp, i, l;
    
        if(!queryString) return {}
        
        if(queryString[0] === '?') {
            queryString = queryString.substr(1);
        }
        // Split into key/value pairs
        queries = queryString.split("&");
        // Convert the array of strings into an object
        for ( i = 0, l = queries.length; i < l; i++ ) {
            temp = queries[i].split('=');
            params[temp[0]] = temp[1];
        }
        return params;
    };

    /**
     * Checks if PAGE preview (latest revision) is being requested (based on query params):
     * http://domain.local/?preview_id=446&preview=true - PAGE PREVIEW
     * 
     * @returns Boolean
     * @memberof PostFetcher
     */
    requestingPagePreview() {
        const queryParams = this.parseQueryString(window.location.search);
        
        return queryParams.preview === 'true' && queryParams.preview_id;
    }

    /**
     * Checks if PAGE draft is being requested (based on query params):
     * http://domain.local/?page_id=26&preview=true - PAGE DRAFT
     * http://domain.local/?p=452&preview=true  - POST DRAFT
     * 
     * @returns Boolean
     * @memberof PostFetcher
     */
    requestingDraft() {
        const queryParams = this.parseQueryString(window.location.search)
        return queryParams.page_id || queryParams.p;
    }

    /**
     * Performs AXIOS request to get revisions for requested post (based on query params)
     * 
     * @returns Promise
     * @memberof PostFetcher
     */
    getPagePreview() {
        const queryParams = this.parseQueryString(window.location.search);

        this.log('PostFetcher::getPosts() -> INTERCEPTION: Page preview requested.');
        
        axios.defaults.headers.common['X-WP-Nonce'] = WP.nonce;

        return axios.get(WP.api_base+'wp/v2/'+this.revisionsFrom+'/'+queryParams.preview_id+'/revisions');
    }

    /**
     * Get page/post/CPT draft based on ID (from query params) using CUSTOM REST ENDPOINT
     * 
     * @returns Promise
     * @memberof PostFetcher
     */
    getDraft() {
        const queryParams = this.parseQueryString(window.location.search);

        const id = queryParams.page_id || queryParams.p;

        this.log('PostFetcher::getPosts() -> INTERCEPTION: Geting draft by ID:', id);

        return axios.get(WP.api_base+WP.theme_name+'/v2/draft', {
            params: { 
                lang: WP.lang,
                id: id,
            }
        });
    }

    requiresFreshData() {
        if(this.requestingPagePreview() || this.requestingDraft()) {
            return true;
        } else {
            return false;
        }
    }

    needsToByApplied() {
        return this.requestingPagePreview() || this.requestingDraft();
    }

    apply() {
        if(this.requestingPagePreview()) 
            return this.getPagePreview();

        if(this.requestingDraft()) 
            return this.getDraft();
    }
}

export default Middleware;